// App.js (Updated with Modern Design)
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import GoogleLogin from "./component/login/GoogleLogin";
import Profile from "./component/profile/Profile";
import NavBar from "./component/NavBar/NavBar.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "./component/NavBar/Dashboard.js";
import './App.css';
import HeroPage from "./component/landing/HeroPage.js";
import MenuManagement from "./component/admin/MenuManagement.js";
import RoleManagement from "./component/admin/RoleManagement.js";
import CollegeManagement from "./component/admin/CollegeManagement.js";
import StudentList from "./component/admin/StudentList.js";
import StaffManagement from "./component/admin/StaffManagement.js";
import AddDaysLeft from "./component/admin/AddDaysLeft.js";
import UploadData from "./component/admin/UploadData.js";
import StaffMenuMapping from "./component/admin/StaffMenuMapping.js";
import AdminChat from "./component/admin/AdminChat.js";
import TestName from "./component/admin/TestName.js";
import AddQuestionType from "./component/admin/AddQuestionType.js";
import AddQuestionTypeMapping from "./component/admin/AddQuestionTypeMapping.js";
import UploadJLPTListeningQuiz from "./component/admin/UploadJLPTListeningQuiz.js";
import CurrentExamPassType from "./component/admin/CurrentExamPassType.js";
import AdminLearningJourney from "./component/admin/AdminLearningJourney.js";
function App() {
  const isAuthenticated = () => {
    const storedUser = localStorage.getItem("user");
    console.log("Stored user:", storedUser);
    return !!storedUser;
  };

  const PrivateRoute = ({ element, ...rest }) => {
    return isAuthenticated() ? <NavBar>{element}</NavBar> : <Navigate to="/login" />;
  };

  const PublicRoute = ({ element }) => {
    return !isAuthenticated() ? element : <Navigate to="/login" />;
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
         
          <Route path="/login"  element={<GoogleLogin />} />
        
          <Route path="/login" element={<PublicRoute element={<GoogleLogin />} />} />
        
          <Route path="/home" element={<HeroPage />} />
          {/* Private Routes */}
          <Route path="/" element={<PrivateRoute element={<Dashboard />} />} />
          <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
          <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
         
           <Route path="/menu-management" element={<PrivateRoute element={<MenuManagement />} />} />
            <Route path="/role-management" element={<PrivateRoute element={<RoleManagement />} />} />
             <Route path="/college-management" element={<PrivateRoute element={<CollegeManagement />} />} />
              <Route path="/student-list" element={<PrivateRoute element={<StudentList />} />} />
               <Route path="/staff-management" element={<PrivateRoute element={<StaffManagement />} />} />
                <Route path="/add-days-left" element={<PrivateRoute element={<AddDaysLeft />} />} />
                 <Route path="/upload-data" element={<PrivateRoute element={<UploadData />} />} />
                 <Route path="/test-name" element={<PrivateRoute element={<TestName />} />} />
                 <Route path="/add-question-type" element={<PrivateRoute element={<AddQuestionType />} />} />
                 <Route path="/question-type-mapping" element={<PrivateRoute element={<AddQuestionTypeMapping />} />} />
                 <Route path="/current-exam-pass-type" element={<PrivateRoute element={<CurrentExamPassType />} />} />
                 <Route path="/upload-jlpt-listening" element={<PrivateRoute element={<UploadJLPTListeningQuiz />} />} />
               
                  <Route path="/staff-menu-mapping" element={<PrivateRoute element={<StaffMenuMapping />} />} />
                  <Route path="/admin-chat" element={<PrivateRoute element={<AdminChat />} />} />
                  <Route path="/admin-chat/learning-journey" element={<PrivateRoute element={<AdminLearningJourney />} />} />
          
          
          {/* 404 Page */}
          <Route path="*" element={<ComingSoonPage />} />
        </Routes>
      </div>
    </Router>
  );
}

// Modern Coming Soon Page Component
const ComingSoonPage = () => {
  return (
    <div className="coming-soon-page">
      <div className="container-fluid vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="floating-animation mb-4">
            <div className="gradient-circle mx-auto"></div>
          </div>
          
          <h1 className="display-4 fw-bold text-primary mb-3">
            Coming Soon
          </h1>
          
          <p className="lead text-muted mb-4">
            We're crafting something extraordinary for you. 
            Stay tuned for an amazing experience!
          </p>
          
          <div className="progress-container mb-4">
            <div className="progress">
              <div 
                className="progress-bar progress-bar-striped progress-bar-animated" 
                style={{width: '75%'}}
              ></div>
            </div>
            <small className="text-muted mt-2">Development in progress - 75% complete</small>
          </div>
          
          <div className="d-flex gap-3 justify-content-center flex-wrap">
            <button 
              className="btn btn-primary btn-lg px-4"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
            <button 
              className="btn btn-outline-primary btn-lg px-4"
              onClick={() => window.location.href = '/'}
            >
              Home Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
